import { html } from 'lit';
const Ai =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' d="M11.281 5.491a.714.714 0 0 0-1.42-.001c-.27 2.345-.971 3.994-2.102 5.126-1.132 1.131-2.781 1.832-5.127 2.103a.714.714 0 0 0 .002 1.42c2.307.26 3.991.962 5.15 2.099 1.153 1.133 1.87 2.782 2.076 5.11a.714.714 0 0 0 1.423 0c.198-2.291.914-3.975 2.073-5.135 1.16-1.16 2.843-1.875 5.134-2.073a.714.714 0 0 0 .002-1.423c-2.33-.207-3.978-.923-5.111-2.077-1.138-1.158-1.838-2.842-2.1-5.149M18.943 2.247a.278.278 0 0 0-.552-.001c-.105.912-.378 1.554-.818 1.993s-1.082.713-1.994.818a.278.278 0 0 0 0 .552c.898.102 1.553.375 2.003.817.45.44.727 1.082.808 1.987a.278.278 0 0 0 .553 0c.077-.891.356-1.546.807-1.997.45-.45 1.105-.729 1.996-.806a.278.278 0 0 0 0-.553c-.905-.08-1.546-.36-1.987-.808-.442-.45-.715-1.105-.816-2.002"/>
  </svg>
`;
export default Ai;
